export const APP_NAME = 'Oceon'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = 'redirectUrl'
export const LIMIT = process.env.REACT_APP_LIMIT || 10
